import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hint_message_dot",
  "use": "icon-hint_message_dot-usage",
  "viewBox": "0 0 4 4",
  "content": "<symbol viewBox=\"0 0 4 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hint_message_dot\">\n<circle cx=\"2\" cy=\"2\" r=\"2\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol